export default __webpack_public_path__ + "static/media/feature1_1.e214e6b4.png";